import { CircularProgress, Box } from "@mui/material";
import { BIBlue } from "../assets/helpers";
import { useSelector } from "react-redux";

function Loader({ fullScreen = false }) {
  const { selectedClientData } = useSelector((state) => state?.main);
  const accentColor =
    selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
      ? selectedClientData?.AccentColor
      : BIBlue;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: fullScreen ? "80vh" : "150px",
        width: "100%",
        py: fullScreen ? 0 : 2
      }}>
      <CircularProgress
        size={36}
        sx={{
          color: accentColor
        }}
      />
    </Box>
  );
}

export default Loader;
